import { GetOneSurveyResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetOneSurveyResponse } from '@/types/Psychosocial';

export class GetOneSurveyMapper {
	constructor(private readonly data: GetOneSurveyResponseDTO) {}

	toDomain(): GetOneSurveyResponse {
		return {
			pending_evaluations: this.data.pending_evaluations < 0 ? 0 : this.data.pending_evaluations,
			total_completed_participations: this.data.total_completed_participations,
			completed_participations: this.data.completed_participations,
			organization_name: this.data.organization_name,
			ideal_sample_size: this.data.ideal_sample_size,
			workstation_name: this.data.workstation_name,
			total_employees: this.data.total_employees,
			company_name: this.data.company_name,
			cellule_name: this.data.cellule_name,
			description: this.data.description,
			sector_name: this.data.sector_name,
			expires_at: this.data.expires_at,
			created_at: this.data.created_at,
			anonymous: this.data.anonymous,
			tool_name: this.data.tool_name,
			comment: this.data.comment,
			name: this.data.name,
			link: this.data.link
		};
	}
}
